module.exports = __webpack_public_path__ + "img/Accessories.af2138a8.jpg";